import { Component } from 'react';

const CHUNK_RELOAD_KEY = 'chunk-load-retry';

export function reloadStaleChunk(error, storage, reload) {
  if (error?.name !== 'ChunkLoadError' || storage.getItem(CHUNK_RELOAD_KEY) === error.message) {
    return false;
  }

  storage.setItem(CHUNK_RELOAD_KEY, error.message);
  reload();
  return true;
}

// Keep a recovery path available even when the app's providers cannot render.
export default class RootErrorBoundary extends Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('RootErrorBoundary caught an error:', error, errorInfo);

    try {
      reloadStaleChunk(error, window.sessionStorage, () => window.location.reload());
    } catch {
      // Keep the rendered fallback when storage or reload is unavailable.
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            padding: 24,
            fontFamily: 'Public Sans, sans-serif',
            maxWidth: 600,
            margin: '40px auto',
            color: '#212B36',
          }}
          role="alert"
        >
          <h1>Não foi possível carregar esta página</h1>
          <p>Tente recarregar a página. Se o problema continuar, volte ao início e tente novamente.</p>
          <button type="button" onClick={() => window.location.reload()} style={{padding: '12px 20px', border: 0, borderRadius: 8, background: '#1B806A', color: '#FFFFFF', font: 'inherit', cursor: 'pointer'}}>Recarregar página</button>
          <a href="/dashboard/app" style={{display: 'inline-block', margin: 16, color: '#005249'}}>Voltar ao início</a>
        </div>
      );
    }
    return this.props.children;
  }
}
